import React from 'react';
import { StickyContainer, Sticky } from 'react-sticky';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Waypoint from 'react-waypoint';
import HelpGroup from './components/HelpGroup';
import scrollToComponent from '../../utils/scrollToComponent';
import ScrollNav from '../ScrollNav';
import Buttonlet from '../Buttonlet';
import MediaXlUp from '../Responsive/MediaXlUp';

import { HELP_ITEMS } from './helpItems';


class Help extends React.Component {
  /**
   * State
   * @type {Object}
   */
  state = {
    activeItem: null,
  }

  /**
   * Goto Item
   * @param  {Object} item
   * @return {undefined}
   */
  gotoItem = (item) => {
    this.setState({
      activeItem: item.id,
    });

    scrollToComponent(this.refs[item.name], {
      offset: 0,
      align: 'top',
    });
  }

  trackPosition = (item) => {
    this.setState({
      activeItem: item.id,
    });
  }


  render() {
    const { history } = this.props;
    const { activeItem } = this.state;

    const helpItems = HELP_ITEMS.map((helpItem, i) => ({
      ...helpItem,
      id: i + 1,
    }));

    const helpGroups = (helpItems && helpItems.length) ? helpItems.map(helpGroup => (
      <div key={helpGroup.name} ref={helpGroup.name}>
        <hr />
        <Waypoint onEnter={() => this.trackPosition(helpGroup)} scrollableAncestor={window} bottomOffset="70%" />
        <HelpGroup data={helpGroup} />
      </div>
    )) : null;

    return (
      <div className="content container" style={{ margin: 10 }}>
        <div className="col-primary col-primary--full">
          <h1 className="heading heading--1" style={{ marginTop: 5 }}>
            <button
              className="button--link"
              onClick={() => { history.goBack(); }}
              style={{
                marginRight: '1rem',
              }}
              type="button"
            >
              <i className="fa fa-arrow-left back-button" />
            </button>
            Help
          </h1>
          <h2 className="heading heading--2">Welcome to Fallen London!</h2>
          <div>
            <p>
              You may be disoriented by the shock of your arrival. We’re here to help.
              {' '}
              <a href="https://community.failbettergames.com" target="_blank" rel="noopener noreferrer">Our forums</a>
              {' '}
              and <a href="https://discordapp.com/invite/59aNpKf" target="_blank" rel="noopener noreferrer">Official Discord</a>
              {' '}
              are also a good place to seek assistance. And if you think you've found a bug,
              {' '}
              please let us know by emailing <a href="mailto:support@failbettergames.com">support@failbettergames.com</a>
            </p>
            <Buttonlet type="book" title="Blog" onClick={() => window.open('http://www.failbettergames.com/news/', '_blank')} />
            <Buttonlet type="twitter" title="Twitter" onClick={() => window.open('https://www.twitter.com/echobazaar', '_blank')} />
            <Buttonlet type="facebook" title="Facebook" onClick={() => window.open('http://www.facebook.com/fallenlondon', '_blank')} />
            <Buttonlet type="quote-left" title="Forums" onClick={() => window.open('http://community.failbettergames.com', '_blank')} />
          </div>
          <br />
          <br />
          <br />
          <StickyContainer style={{ height: 'auto' }} className="row">
            <MediaXlUp>
              <div className="nav nav--stacked nav--stacked--1-of-4 nav--stacked--roman">
                <Sticky>
                  {
                    ({ style }) => (
                      <ScrollNav
                        style={style}
                        data={helpItems}
                        gotoItem={this.gotoItem}
                        active={activeItem}
                      />
                    )
                  }
                </Sticky>
              </div>
            </MediaXlUp>
            <div className="stack-content stack-content--3-of-4">
              {helpGroups}
            </div>
          </StickyContainer>
          <p>...thank you. Delicious friend.</p>
        </div>
      </div>
    );
  }
}

Help.displayName = 'Help';

export default withRouter(connect()(Help));
